/**
 * Espelha OrigemConsultaDistribuicaoSefazEnum da API DFe (calculado, sem tabela); trafega como inteiro.
 */
export enum OrigemConsultaDistribuicaoSefazEnum {
  Automatica = 1,
  Manual = 2,
  PorChave = 3,
}

/** Rótulo de cada origem, igual à Description do enum da API. */
export const OrigemConsultaDistribuicaoSefazDescricao: { [key: number]: string } = {
  [OrigemConsultaDistribuicaoSefazEnum.Automatica]: 'Automática',
  [OrigemConsultaDistribuicaoSefazEnum.Manual]: 'Manual',
  [OrigemConsultaDistribuicaoSefazEnum.PorChave]: 'Por chave',
};
